module.exports = __webpack_public_path__ + "media/Strc.ae445afd.jpg";